export class Prova {
  id: string;
  disciplinaId: string;
  nomeProva: string;
  dependeProva: string;
  questoes: Questao[];
  constructor() {}
}

export class Questao {
  id: string;
  descricao: string;
  a: string;
  b: string;
  c: string;
  d: string;
  resposta: string;
  constructor() {}
}
